import { createComponent } from '@ycos/fela'
import { getFontStyles, createFontStyle } from '../'

const Paragraph = createComponent(
  'paragraph',
  ({ theme, textAlign, inverseColor, dropCaps, smallMargin }) => {
    const {
      spacingMultiplier,
      typography,
      custom: { link, paragraph }
    } = theme
    const { name, type, ...a } = link
    const styles = getFontStyles(typography, { type: 'Paragraph', name: paragraph.name })

    return {
      ...styles,
      textAlign,
      direction: 'ltr',
      color: inverseColor ? paragraph.inverseColor : paragraph.color,
      margin: smallMargin ? `0 0 ${2 * spacingMultiplier}px` : `0 0 ${3 * spacingMultiplier}px`,
      fontSize: paragraph.fontSize || styles.fontSize,
      '> a': a.color || a.default,
      '> a:hover': a.hover,
      ':first-of-type:first-letter': dropCaps
        ? {
            float: 'left',
            fontSize: `${parseInt(styles.fontSize) * styles.lineHeight * 4.9}px`,
            lineHeight: `${parseInt(styles.fontSize) * styles.lineHeight * 4 - 3}px`,
            marginRight: '10px'
          }
        : undefined
    }
  },
  'p'
)

export const Strong = createFontStyle('Paragraph', { type: 'Paragraph', tagName: 'strong', name: '4' }, ({ textAlign, inverseColor, theme }) => {
  const {
    spacingMultiplier,
    custom: { link, strong }
  } = theme
  const { name, type, ...a } = link

  return {
    fontWeight: strong.weight,
    color: inverseColor ? strong.inverseColor : strong.color,
    fontSize: strong.fontSize,
    margin: `0 0 ${3 * spacingMultiplier}px`,
    '> a': a.default,
    '> a:hover': a.hover,
    textAlign
  }
})

export default Paragraph
